export const VENUE_STATES = ['in play', 'confirmed', 'concluded', 'cancelled'];
export const CLIENT_STATES = ['pending', 'confirmed', 'concluded', 'cancelled'];
